import { connect } from 'react-redux'

import OrderItem from '@components/order/edit/sections/OrderItem'

import presenters from '@presenters'
import services from '@services'

const mapStateToProps = (state) => {
  const { user } = state

  return { user }
}

const mapDispatchToProps = () => {
  const { isAuthorized, pColorHashString } = presenters
  const { UIService } = services
  const displayAlert = ({ message, title }) =>
    UIService.Alert.showPopup({ message, title })

  return {
    displayAlert,
    isAuthorized,
    pColorHashString,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderItem)
